<template>
	<div class="pre-made-treatment-form">
		<v-form ref="form">
			<v-row no-gutters>
				<v-col cols="12" md="12">
					<v-text-field
						v-model="treatment.name"
						:rules="[required]"
						:label="$gettext('Treatment Name')"
						outlined
					></v-text-field>
				</v-col>
				<v-col cols="12" md="12">
					<RichTextEditor
						ref="editor"
						context="new-treatment"
						:text="treatment.text"
						:category="category"
					/>
				</v-col>
				<v-col cols="12" md="12">
					<v-btn color="primary" class="float-right mt-2" @click="saveTreatment">
						<translate v-if="!edit">Create</translate>
						<translate v-else>Save</translate>
					</v-btn>
					<v-btn v-if="edit" color="primary" class="mt-2" @click="goToMainPage">
						<translate>Cancel</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-form>
	</div>
</template>

<script>
import RichTextEditor from "@/components/RichTextEditor.vue";

export default {
	name: "PreMadeTreatment",
	props: {
		treatment: { default: () => ({ name: "", text: "" }) },
		edit: { default: false },
		category: {}
	},
	components: {
		RichTextEditor
	},
	data: () => ({}),
	computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
	},
	methods: {
		resetFields() {
			this.treatment.name = "";
			this.treatment.text = "";
			this.$refs.editor.resetField();
		},
		goToMainPage() {
			this.$emit("cancel");
		},
		saveTreatment() {
			if (this.$refs.form.validate()) {
				console.log(this.$refs.editor.getHTML());
				this.treatment.text = this.$refs.editor.getHTML();
				if (!this.edit) {
					this.$emit("new-treatment", this.treatment);
				} else {
					this.$emit("edit-treatment", this.treatment);
				}
			}
		}
	}
};
</script>